"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAudio = void 0;
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
// import RNFS from "react-native-fs";
// import TrackPlayer from "react-native-track-player";
const react_redux_1 = require("react-redux");
const apis_1 = require("../common/apis");
const application_host_1 = require("../common/application-host");
const constants_1 = require("../common/constants");
const AudioProvider_1 = require("../providers/AudioProvider");
const useDevice_1 = require("./useDevice");
const useAudio = () => {
    const { isWebDevice } = (0, useDevice_1.useDevice)();
    const { audioCache } = (0, react_1.useContext)(AudioProvider_1.audioContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [streaming, setStreaming] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const handleStop = async () => {
        // await TrackPlayer.pause();
        setIsPlaying(false);
    };
    /**
     *
     */
    const playAudio = (0, react_1.useCallback)(async (message, messageId, voice, voiceSpeed) => {
        const sourceFilePath = getAudioRef(messageId, voiceSpeed);
        // setLoading(true);
        const newMessegeRequest = {
            text: `${message}`,
            voice: voice || "echo",
            speed: voiceSpeed || constants_1.DEFAULT_SPEED_RATE,
        };
        await setIsPlaying(true);
        setStreaming(true);
        try {
            const headers = {
                "Content-Type": "application/json",
            };
            // Create an Axios client with headers
            const responseNormal = await axios_1.default.post(`${application_host_1.ADD_API}${apis_1.APP_CONSTANTS.audio.speech}`, newMessegeRequest, {
                headers: headers,
                responseType: "json", // Change to json to get the structured response
            });
            if (isWebDevice && typeof sourceFilePath !== 'string') {
                // Handle the Buffer response format
                if (responseNormal.data.success && responseNormal.data.data) {
                    const audioBuffer = responseNormal.data.data;
                    // Convert the buffer data array to Uint8Array
                    let audioData;
                    if (audioBuffer.type === "Buffer" && Array.isArray(audioBuffer.data)) {
                        audioData = new Uint8Array(audioBuffer.data);
                    }
                    else {
                        // Fallback for direct array buffer
                        audioData = new Uint8Array(audioBuffer);
                    }
                    // Create blob with proper MIME type for MP3
                    const blob = new Blob([audioData], { type: 'audio/mpeg' });
                    sourceFilePath.url = URL.createObjectURL(blob);
                    sourceFilePath.isCached = true;
                }
                else {
                    console.error("Invalid response format:", responseNormal.data);
                }
            }
            // await RNFS.writeFile(
            //   sourceFilePath,
            //   responseNormal.request._response,
            //   "base64"
            // );
            // await TrackPlayer.reset();
            // await TrackPlayer.add([
            //   {
            //     id: "1",
            //     url: sourceFilePath,
            //     // artwork: require('./assets/image.jpg'),
            //     // title: "Make a cup of coffe",
            //     // artist: "Powfu",
            //     duration: 40,
            //   },
            // ]);
            // TrackPlayer.play();
            setStreaming(false);
            // await setIsPlaying(false);
        }
        catch (e) {
            // console.log("Error while calling it...,", Object.keys(e), e?.response);
            setStreaming(false);
            await setIsPlaying(true);
            console.error("Error playing audio:", e);
        }
    }, []);
    /**
     *
     * @param message
     */
    const handlePlay = async (message, voice, voiceSpeed) => {
        if (isPlaying) {
            // TrackPlayer.reset();
        }
        await playAudio(message || "", "0", voice, voiceSpeed);
    };
    /**
     *
     * @param conversationId
     * @param messageId
     * @returns
     */
    const getAudioRef = (messageId, speed) => {
        const audioHash = `${messageId ?? ''}${speed ?? ''}`;
        if (!audioCache.has(audioHash)) {
            audioCache.set(audioHash, {
                url: "",
                isCached: false
            });
        }
        return audioCache.get(audioHash);
    };
    getAudioRef();
    const isFileExpired = async (fileReference) => {
        try {
            if (typeof fileReference !== 'string') {
                return !fileReference.isCached;
            }
            // Check if the file exists
            // const fileExists = await RNFS.exists(filePath);
            // if (!fileExists) {
            //   return true; // File doesn't exist, treat as expired
            // }
            // Get the last modification time of the file
            // const stats = await RNFS.stat(filePath);
            // console.log("stats:", stats);
            // const lastModifiedTimestamp = stats.mtime; //.getTime();
            // Check if the file is older than the expiration duration
            const currentTime = Date.now();
            // const isExpired =
            //   currentTime - lastModifiedTimestamp > CACHE_EXPIRATION_DURATION;
            // return isExpired;
        }
        catch (error) {
            console.error("Error checking file expiration:", error);
            return true; // Treat as expired in case of an error
        }
    };
    const selectedVoice = (0, react_redux_1.useSelector)((state) => state.getUserOptions.selectedVoice);
    const voiceSpeedIndex = (0, react_redux_1.useSelector)((state) => state.getUserOptions.voiceSpeed);
    /**
     *
     */
    const cacheAudioFile = async (sourceFileReference, message, speed) => {
        try {
            // setLoading(true);
            const newMessegeRequest = {
                text: `${message}`,
                voice: selectedVoice || "echo",
                speed: constants_1.VOICE_SPEED_LIST?.[(speed ?? voiceSpeedIndex) || 1 || 1] || 1,
            };
            const headers = {
                "Content-Type": "application/json",
            };
            const responseNormal = await axios_1.default.post(`${application_host_1.ADD_API}${apis_1.APP_CONSTANTS.audio.speech}`, newMessegeRequest, {
                headers: headers,
                responseType: "json", // Change to json to get the structured response
            });
            if (isWebDevice && typeof sourceFileReference !== 'string') {
                // Handle the Buffer response format
                if (responseNormal.data.success && responseNormal.data.data) {
                    const audioBuffer = responseNormal.data.data;
                    // Convert the buffer data array to Uint8Array
                    let audioData;
                    if (audioBuffer.type === "Buffer" && Array.isArray(audioBuffer.data)) {
                        audioData = new Uint8Array(audioBuffer.data);
                    }
                    else {
                        // Fallback for direct array buffer
                        audioData = new Uint8Array(audioBuffer);
                    }
                    // Create blob with proper MIME type for MP3
                    const blob = new Blob([audioData], { type: 'audio/mpeg' });
                    sourceFileReference.url = URL.createObjectURL(blob);
                    sourceFileReference.isCached = true;
                }
                else {
                    console.error("Invalid response format:", responseNormal.data);
                }
            }
            // await RNFS.writeFile(
            //   sourceFileReference,
            //   responseNormal.request._response,
            //   "base64"
            // );
        }
        catch (e) {
            console.error("Error in Audio:", e);
        }
    };
    /**
     *
     */
    const streamAudioFile = async (sourceFileReference, message, speed) => {
        try {
            // setLoading(true);
            const newMessegeRequest = {
                text: `${message}`,
                voice: selectedVoice || "echo",
                // response_format: "opus",
                // stream: true,
                speed: constants_1.VOICE_SPEED_LIST?.[(speed ?? voiceSpeedIndex) || 1 || 1] || 1,
            };
            const headers = {
                "Content-Type": "application/json",
            };
            const responseNormal = await axios_1.default.post(`${application_host_1.ADD_API}${apis_1.APP_CONSTANTS.audio.speech}`, newMessegeRequest, {
                headers: headers,
                responseType: "json", // Change to json to get the structured response
            });
            if (isWebDevice && typeof sourceFileReference !== 'string') {
                // Handle the Buffer response format
                if (responseNormal.data.success && responseNormal.data.data) {
                    const audioBuffer = responseNormal.data.data;
                    // Convert the buffer data array to Uint8Array
                    let audioData;
                    if (audioBuffer.type === "Buffer" && Array.isArray(audioBuffer.data)) {
                        audioData = new Uint8Array(audioBuffer.data);
                    }
                    else {
                        // Fallback for direct array buffer
                        audioData = new Uint8Array(audioBuffer);
                    }
                    // Create blob with proper MIME type for MP3
                    const blob = new Blob([audioData], { type: 'audio/mpeg' });
                    sourceFileReference.url = URL.createObjectURL(blob);
                    sourceFileReference.isCached = true;
                }
                else {
                    console.error("Invalid response format:", responseNormal.data);
                }
            }
            // console.log("responseNorma voice message:", responseNormal);
            // await RNFS.writeFile(
            //   sourceFilePath,
            //   responseNormal.request._response,
            //   "base64"
            // );
        }
        catch (e) {
            console.error("Error in Audio:", e);
        }
    };
    return {
        isLoading,
        handleStop,
        playAudio,
        handlePlay,
        isPlaying,
        setIsPlaying,
        getAudioRef,
        isFileExpired,
        cacheAudioFile,
        streamAudioFile,
    };
};
exports.useAudio = useAudio;
